import { render } from "./BarChart.vue?vue&type=template&id=ee8daa2e&scoped=true&ts=true"
import script from "./BarChart.vue?vue&type=script&lang=ts"
export * from "./BarChart.vue?vue&type=script&lang=ts"

import "./BarChart.vue?vue&type=style&index=0&id=ee8daa2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8daa2e"]])

export default __exports__